import type { BackendAdapter, BackendFilter, FilterValues } from "../types";
import { pushBooleanFiltersIfSet, pushDateRangeFilters, pushInArrayOrExactFilterIfSet } from "../types";
import type { SubscriptionRow } from "./columns";

export const subscriptionsBackendAdapter: BackendAdapter<SubscriptionRow> = {
	buildFilters: (filterValues: FilterValues): BackendFilter[] => {
		const filters: BackendFilter[] = [];

		pushInArrayOrExactFilterIfSet(filters, "product", filterValues.product);
		pushInArrayOrExactFilterIfSet(filters, "proClubId", filterValues.proClubId);
		pushInArrayOrExactFilterIfSet(filters, "teamGroupId", filterValues.teamGroupId);
		pushInArrayOrExactFilterIfSet(filters, "gameOptions", filterValues.gameOptions);
		pushInArrayOrExactFilterIfSet(filters, "eyeballAddons", filterValues.eyeballAddons);
		pushBooleanFiltersIfSet(filters, filterValues, ["active"]);
		pushDateRangeFilters(filters, filterValues, ["startDate", "expirationDate"]);

		if (filterValues.pipedriveDealId) {
			filters.push({
				field: "pipedriveDealId",
				type: "search",
				value: filterValues.pipedriveDealId,
			});
		}

		return filters;
	},
};
